import React from 'react';
import { Form } from 'ui-lib';
import { IRecordPickerFormItemProps } from './record-picker.types';
import { RecordPicker } from './record-picker';

export const RecordPickerFormItem = <T,>(props: IRecordPickerFormItemProps<T>): JSX.Element => {
    const { name, label, isRequired, ...pickerProps } = props;
    const requiredMessage = props.selectionType === 'single'
        ? 'Please select a record'
        : 'Please select at least one record';

    return (
        <Form.Item
            name={name}
            label={label}
            labelAlign='right'
            required={isRequired}
            rules={isRequired ? [{ required: true, type: 'array', min: 1, message: requiredMessage }] : undefined}
        >
            <RecordPicker {...pickerProps} />
        </Form.Item>
    );
};
